import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const updateConfimation = (data) => {
  return function () {
    return AssessmentServiceApi.updateConfirmation(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const downloadAssessmentResult = (
  userGUID,
  assessmentAttemptId,
  languageCode
) => {
  return function () {
    return AssessmentServiceApi.downloadAssessmentResult(
      userGUID,
      assessmentAttemptId,
      languageCode
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const createGuestUserWithoutEmail = (data) => {
  return function () {
    return AssessmentServiceApi.createGuestUserWithoutEmail(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};

export {
  updateConfimation,
  downloadAssessmentResult,
  createGuestUserWithoutEmail,
};
